import { Grid } from '@mui/material';
import { DashboardCardTitle } from '../../dashboard-card-title/dashboard-card-title.component';
import { useLockerUtilisationHeaderStyles } from './locker-utilisation-header.styles';

export function LockerUtilisationHeader() {
  const classes = useLockerUtilisationHeaderStyles();
  return (
    <Grid
      className={classes.root}
      container
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <Grid>
        <DashboardCardTitle title="Capacity" />
      </Grid>
      <Grid>
        <p className={classes.timePeriod}>RIGHT NOW</p>
      </Grid>
    </Grid>
  );
}
